import { createSlice } from '@reduxjs/toolkit';

interface BlockchainState {
	endpoint: string;
}

const blockchainSlice = createSlice({
	name: 'blockchain',
	initialState: {
		endpoint: ''
	} as BlockchainState,
	reducers: {
		setRPCEndpoint: (state, action) => {
			state.endpoint = action.payload;
		},
	},
});

const { reducer, actions } = blockchainSlice;

export const { setRPCEndpoint } = actions;
export default reducer;
